import { useMonitor } from '../use-monitor';

export function useMonitorDeclineIssueLoad() {
  return useMonitor('decline-issue-load');
}
